import { IAppState } from '../../common/state';

export function getIsFavourite({ newbuildingInformation }: IAppState): boolean | undefined {
  return newbuildingInformation?.isFavorite;
}
